export default __webpack_public_path__ + "static/media/image.e1a9eb05.svg";